import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WhatIDoPage from "./pages/WhatIDoPage";
import ThinkingPage from "./pages/ThinkingPage";
import ThinkingPostPage from "./pages/ThinkingPostPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="what-i-do" element={<WhatIDoPage />} />
          <Route path="thinking" element={<ThinkingPage />} />
          <Route path="thinking/:postId" element={<ThinkingPostPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
